<template>
  <v-container fluid grid-list-sm text-xs-center>
    <v-layout row wrap>
      <v-flex xs3>
      
        <v-card>
          <v-toolbar color="primarydark" dark extended>
      
            <v-avatar size="40px" class="primary">{{projetos.length}}</v-avatar>
            <v-toolbar-title>Projetos</v-toolbar-title>
            <v-spacer></v-spacer>
            
             <ProjetoCriar :numero="nextNumber" />

             <v-flex xs12 slot="extension">
                <v-text-field
                  append-icon="search" 
                  label="Localizar"
                  value=""
                  single-line
                  full-width
                  hide-details
                ></v-text-field>
              </v-flex>
           
            
          </v-toolbar>
          <v-list dark two-line subheader class="list-projetos">
            <template v-for="(projeto, index) in projetos">
              <v-divider></v-divider>
              <v-list-tile :key="projeto['.key']" @click="mostrarProjeto(index)">
              <v-list-tile-avatar class="codigo">
             {{projeto.codigo}}
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{projeto.curso}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{projeto.faculdade}}<br />
                  </v-list-tile-sub-title>
                </v-list-tile-content>
        
              </v-list-tile>
            </template>
          </v-list>
        </v-card>




      </v-flex>
      <v-flex xs9>
        <v-container fluid grid-list-xs text-xs-center>

        <v-layout row wrap>

       <v-flex xs12>
        <v-card>

          <v-toolbar color="primary" dark>
            <v-toolbar-title>
              <ProjetoEditar 
              v-if="projetoNo"
              :projeto="projeto" />

              {{projeto.codigo}} - {{projeto.curso}} - {{projeto.faculdade}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon :to="'/projetofotos/' + projeto['.key']" target="_blank">
                <v-icon>photo</v-icon>
              </v-btn>
            <a :href="`${downloadJSON(formandos)}`" :download="`${projeto['.key']}.json`">
              <v-btn icon>
                <v-icon>file_download</v-icon>
              </v-btn>
            </a>
          </v-toolbar>

          
        </v-card>

      
 </v-flex>



         <v-flex xs4>
      
       <v-card>
          <v-toolbar color="primary" dark>
           <v-avatar size="40px" class="secondary">{{formandos.length}}</v-avatar>

            <v-toolbar-title>Formandos</v-toolbar-title>
            <v-spacer></v-spacer>
             
            <FormandoCriar v-if="projetoNo"
             :projetoNo="projetoNo"
             :projetoCodigo="projetoCodigo" 
             :projetoCurso="projetoCurso" 
             :projetoFaculdade="projetoFaculdade"
            /> 
 
           
          </v-toolbar>
          <v-list two-line class="list-formandos">
            <template v-for="(formando, index) in formandos">
              <v-divider inset></v-divider>
              <v-list-tile :class="{active: index == indexFormando}" avatar :key="formando['.key']" @click="mostrarFormando(index)">
                <v-list-tile-avatar>
                  <img :src="formando.photoURL">
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{formando.nomecompleto}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{formando['.key']}}<br>
                    <!-- <span v-if="formando.login"> {{formando.login | moment('DD/MM/YYYY')}} </span> -->
                    <span>{{formando.telefone}}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon ripple>
                   <FormandoEditar 
                    :formando="formando"
                    :projetoNo="projeto['.key']" /> 
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-card>

         </v-flex>

         <v-flex xs8>

      <v-card>
          <v-toolbar color="primary" dark>

            <ProjetoPrazo v-if="projetoNo"
             :projeto="projeto"
             :formandos="formandos"
            /> 

            {{formando.email}}


            <v-spacer></v-spacer>
            <v-btn icon @click="previusFormando(indexFormando)">
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn icon @click="nextFormando(indexFormando)">
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="formando-preview">
            <v-avatar v-if="formando.photoURL" size="150px" class="mb-3">
              <img :src="formando.photoURL">
            </v-avatar>

              <h1>{{formando.nome}} </h1>
              <h2>{{formando.sobrenome}}</h2>

            <h3>{{formando.pai}}
              <span v-if="formando.paiim"> (in memoriam)</span>
            </h3>
            <h3>{{formando.mae}}
              <span v-if="formando.maeim"> (in memoriam)</span>
            </h3>
            <v-toolbar color="grey lighten-2" class="mt-4 mb-4">
              <v-toolbar-title>Agradecimento Familiar</v-toolbar-title>
            </v-toolbar>
            <h2>{{formando.agradecimentos.familiar.titulo}}</h2>
            <h3>{{formando.agradecimentos.familiar.nomes}}</h3>
            <p>
              <pre>{{formando.agradecimentos.familiar.texto}}</pre>
            </p>
            <img class="fotos" v-if="formando.fotos" :src="formando.fotos.fotoFamilia">

            <v-toolbar color="grey lighten-2" class="mt-4 mb-4">
              <v-toolbar-title>Agradecimento Pessoal</v-toolbar-title>
            </v-toolbar>
            <h2>{{formando.agradecimentos.pessoal.titulo}}</h2>
            <p>
              <pre>{{formando.agradecimentos.pessoal.texto}}</pre>
            </p>
            <img class="fotos" v-if="formando.fotos" :src="formando.fotos.fotoCrianca">

            <v-toolbar color="grey lighten-2" class="mt-4 mb-4">
              <v-toolbar-title>Encarte</v-toolbar-title>
            </v-toolbar>
            <p>
              <pre>{{formando.agradecimentos.encarte.texto}}</pre>
            </p>

            <v-toolbar color="grey lighten-2" class="mt-4 mb-4">
              <v-toolbar-title>Fotos Mural</v-toolbar-title>
            </v-toolbar>
              <img class="fotos" v-if="formando.fotos" :src="formando.fotos.fotoMural1">
              <img class="fotos" v-if="formando.fotos" :src="formando.fotos.fotoMural2">
              <img class="fotos" v-if="formando.fotos" :src="formando.fotos.fotoMural3">
              <img class="fotos" v-if="formando.fotos" :src="formando.fotos.fotoMural4">
              <img class="fotos" v-if="formando.fotos" :src="formando.fotos.fotoMural5">
              <img class="fotos" v-if="formando.fotos" :src="formando.fotos.fotoMural6">
              <img class="fotos" v-if="formando.fotos" :src="formando.fotos.fotoMural7">
     

          </v-card-text>
        </v-card>


      
         </v-flex>
        </v-layout> 
        </v-container>     
      </v-flex>
    </v-layout>

  </v-container>
</template>

<script>
import ProjetoCriar from "@/components/ProjetoCriar.vue";
import ProjetoEditar from "@/components/ProjetoEditar.vue";
import ProjetoPrazo from "@/components/ProjetoPrazo.vue";
import FormandoEditar from "@/components/FormandoEditar.vue";
import FormandoCriar from "@/components/FormandoCriar.vue";

import { mask } from "vue-the-mask";

export default {
  components: {
    ProjetoCriar,
    ProjetoEditar,
    ProjetoPrazo,
    FormandoEditar,
    FormandoCriar
  },
  directives: { mask },
  data() {
    return {
      menu: false,
      editar: false,
      user: {},
      formandos: [],
      formando: {
        agradecimentos: {
          familiar: {
            titulo: "",
            nomes: "",
            texto: ""
          },
          pessoal: {
            titulo: "",
            texto: ""
          },
          encarte: {
            texto: ""
          }
        },
        fotos: {}
      },
      projeto: {},
      projetoNo: "",
      projetoCodigo: "",
      projetoCurso: "",
      projetoFaculdade: "",
      projetos: {},
      indexFormando: 0,
      tileActive: ""
    };
  },
  computed: {
    nextNumber() {
      return "20181001";
    }
  },
  mounted() {
    this.$auth.onAuthStateChanged(user => {
      if (user) {
        this.user = user;
        this.emailkey = user.email.replace(/[.]/g, ",");
        this.$bindAsObject("usuario", this.$db.ref(`users/${this.emailkey}`));
        this.$bindAsArray("projetos", this.$db.ref(`projetos`));
      } else {
        this.$router.push("/login");
      }
    });
  },
  methods: {
    formatJSON(theJSON) {
      return JSON.stringify(theJSON, true, 2);
    },
    downloadJSON(theJSON) {
      return (
        "data:text/json;charset=utf-8," +
        encodeURIComponent(JSON.stringify(theJSON))
      );
    },
    mostrarProjeto(index) {
      this.projeto = this.projetos[index];
      this.projetoNo = this.projeto[".key"];
      this.projetoCodigo = this.projeto.codigo;
      this.projetoCurso = this.projeto.curso;
      this.projetoFaculdade = this.projeto.faculdade;
      this.$bindAsArray(
        "formandos",
        this.$db
          .ref(`projetos/${this.projeto[".key"]}/formandos`)
          .orderByChild("nomecompleto")
      );
      // this.mostrarFormando(0);
    },
    mostrarFormando(index) {
      this.indexFormando = index;
      this.formando = this.formandos[index];
      if (!this.formando.agradecimentos) {
        this.formando.agradecimentos = {
          familiar: {
            titulo: "",
            nomes: "",
            texto: ""
          },
          pessoal: {
            titulo: "",
            texto: ""
          },
          encarte: {
            texto: ""
          }
        };
      }
      if (!this.formando.agradecimentos.familiar) {
        this.formando.agradecimentos.familiar = {
          titulo: "",
          nomes: "",
          texto: ""
        };
      }
      if (!this.formando.agradecimentos.pessoal) {
        this.formando.agradecimentos.pessoal = {
          titulo: "",
          texto: ""
        };
      }
      if (!this.formando.agradecimentos.encarte) {
        this.formando.agradecimentos.encarte = {
          texto: ""
        };
      }
    },
    nextFormando(index) {
      this.indexFormando = index + 1;
      if (this.indexFormando === this.formandos.length) {
        this.indexFormando = 0;
      }
      this.mostrarFormando(this.indexFormando);
    },
    previusFormando(index) {
      if (index === 0) {
        index = this.formandos.length;
      }
      this.indexFormando = index - 1;
      this.mostrarFormando(this.indexFormando);
    },
    cadastrar() {
      let email = this.email.toLowerCase();
      let emailkey = email.replace(/[.]/g, ",");
      let updates = {};
      let agradecimentos = {
        familiar: {
          titulo: "Aos que amo",
          nomes: "",
          texto: ""
        },
        pessoal: {
          titulo: "Agradecimento Pessoal",
          texto: ""
        },
        encarte: {
          texto: ""
        }
      };
      updates["/users/" + emailkey + "/nomecompleto"] = this.nome;
      updates[
        "/users/" + emailkey + "/projeto/projetos/" + this.numero + "/curso/"
      ] = this.curso;
      updates[
        "/users/" +
          emailkey +
          "/projeto/projetos/" +
          this.numero +
          "/faculdade/"
      ] = this.faculdade;
      updates[
        "/users/" +
          emailkey +
          "/projeto/projetos/" +
          this.numero +
          "/dados/agradecimentos/"
      ] = agradecimentos;
      updates["/users/" + emailkey + "/projeto/atual"] = this.numero;
      updates[
        "/projetos/" + this.numero + "/formandos/" + emailkey + "/nomecompleto"
      ] = this.nomecompleto;
      updates["/projetos/" + this.numero + "/curso"] = this.curso;
      updates["/projetos/" + this.numero + "/faculdade"] = this.faculdade;
      updates["/find/" + emailkey + "/nomecompleto"] = this.nome;
      updates["/find/" + emailkey + "/contrato/"] = this.numero;
      updates["/find/" + emailkey + "/curso/"] = this.curso;
      updates["/find/" + emailkey + "/faculdade/"] = this.faculdade;
      this.$db.ref().update(updates);
      this.nome = "";
      this.email = "";
    }
  }
};
</script>
<style lang="stylus">
.codigo
  font-size 16px
  font-weight 700
  margin-right 20px
a
  text-decoration none
.list-projetos
  height: calc(100vh - 231px)
  overflow-y: auto
.list-formandos
  height: calc(100vh - 240px)
  overflow-y: auto
.active
  .list__tile
    background-color rgba(0,0,0,0.15) !important
.formando-preview
  height: calc(100vh - 240px)
  overflow-y: auto
  padding 30px
  .fotos
    max-height 250px
    max-width 80%
  h1
    font-size 32px
    font-weight: 700
    margin-bottom 6px
  h2
    font-size 24px
    font-weight: 700
    line-height: 1.2
    margin-bottom 6px
  h3
    font-size: 18px
    line-height: 1.2
    margin-bottom 6px
  p
    font-size: 14px
    line-height: 1.5
    pre
      text-align justify
      white-space: pre-wrap
      word-wrap: break-word
      font-family: inherit
</style>



// WEBPACK FOOTER //
// src/views/AdminProjeto.vue